/* Nile Debate — The Arena shared scripts. reduced-motion aware. */
(function(){
  var t=document.getElementById('navtoggle'),l=document.getElementById('navlinks');
  if(t&&l){t.addEventListener('click',function(){l.classList.toggle('open')});
    l.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){l.classList.remove('open')})});}
  var y=document.getElementById('yr');if(y)y.textContent=new Date().getFullYear();
  var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.14});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
  var cio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;cio.unobserve(e.target);
    var el=e.target,end=+el.dataset.count,suf=el.dataset.suffix||'';
    if(reduce){el.textContent=end+suf;return;}
    var s=null,dur=1400;
    function step(ts){if(!s)s=ts;var p=Math.min((ts-s)/dur,1);el.textContent=Math.floor(p*end)+suf;if(p<1)requestAnimationFrame(step);}
    requestAnimationFrame(step);
  })},{threshold:.5});
  document.querySelectorAll('[data-count]').forEach(function(el){cio.observe(el)});
  /* Sale / preorder countdown. data-countdown holds epoch SECONDS. */
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var end=parseInt(el.getAttribute('data-countdown'),10);
    if(!end||isNaN(end))return;
    var endMs=end*1000;
    function tick(){
      var diff=endMs-Date.now();
      if(diff<=0){var wrap=el.closest('.preorder');if(wrap)wrap.style.display='none';return;}
      var d=Math.floor(diff/86400000),h=Math.floor((diff%86400000)/3600000),m=Math.floor((diff%3600000)/60000);
      if(d>0){el.textContent='Ends in '+d+'d '+h+'h';}
      else if(h>0){el.textContent='Ends in '+h+'h '+m+'m';}
      else{el.textContent='Ends in '+m+'m';}
    }
    tick();setInterval(tick,60000);
  });
  /* Product gallery — click a thumbnail to swap the main image */
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main=g.querySelector('[data-main-image]');
    if(!main)return;
    var thumbs=g.querySelectorAll('[data-thumb]');
    Array.prototype.forEach.call(thumbs,function(btn){
      btn.addEventListener('click',function(){
        var full=btn.getAttribute('data-full');
        if(!full)return;
        Array.prototype.forEach.call(thumbs,function(x){x.classList.remove('on');x.removeAttribute('aria-current')});
        btn.classList.add('on');btn.setAttribute('aria-current','true');
        main.src=full;
      });
    });
  });
  /* Judge.me review photos: their widget lazy-loads via data-src and we don't load their JS. */
  function hydrateReviewPics(scope){
    (scope||document).querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach(function(im){
      if(!im.getAttribute('src')){im.setAttribute('src',im.getAttribute('data-src'));}
      var a=im.closest('.jdgm-rev__pic-link');
      if(a){a.classList.remove('jdgm--loading');}
    });
  }
  /* Reviewers paste bare URLs. Turn them into links without touching existing markup. */
  var URL_RE=/(https?:\/\/[^\s<>"']+[^\s<>"'.,:;!?)\]])/g;
  function linkifyReviewBodies(scope){
    var bodies=(scope||document).querySelectorAll('.jdgm-rev__body');
    Array.prototype.forEach.call(bodies,function(body){
      if(body.getAttribute('data-linkified'))return;
      body.setAttribute('data-linkified','1');
      var walker=document.createTreeWalker(body,NodeFilter.SHOW_TEXT,null);
      var nodes=[],n;
      while((n=walker.nextNode())){
        if(n.parentNode&&n.parentNode.closest&&n.parentNode.closest('a'))continue;
        if(URL_RE.test(n.nodeValue)){nodes.push(n);}
        URL_RE.lastIndex=0;
      }
      nodes.forEach(function(node){
        var frag=document.createDocumentFragment();
        var text=node.nodeValue,last=0,m;
        URL_RE.lastIndex=0;
        while((m=URL_RE.exec(text))!==null){
          if(m.index>last){frag.appendChild(document.createTextNode(text.slice(last,m.index)));}
          var a=document.createElement('a');
          a.href=m[0];a.textContent=m[0];a.target='_blank';a.rel='nofollow noopener';
          frag.appendChild(a);
          last=m.index+m[0].length;
        }
        if(last<text.length){frag.appendChild(document.createTextNode(text.slice(last)));}
        node.parentNode.replaceChild(frag,node);
      });
    });
  }
  hydrateReviewPics(document);
  linkifyReviewBodies(document);
  /* "See more reviews" — pulls the next page from Judge.me's public widget API */
  document.querySelectorAll('[data-jdgm-more]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var page=parseInt(btn.getAttribute('data-page'),10)+1;
      var per=parseInt(btn.getAttribute('data-per-page'),10)||5;
      var total=parseInt(btn.getAttribute('data-total'),10)||0;
      var shop=btn.getAttribute('data-shop');
      var prod=btn.getAttribute('data-product-id');
      var status=document.querySelector('[data-jdgm-status]');
      var list=document.querySelector('.jdgm-rev-widg__reviews');
      if(!list)return;
      var label=btn.textContent;
      btn.disabled=true;btn.textContent='Loading…';
      var url='https://api.judge.me/reviews/reviews_for_widget'
        +'?url='+encodeURIComponent(shop)
        +'&shop_domain='+encodeURIComponent(shop)
        +'&platform=shopify&per_page='+per+'&page='+page
        +'&product_id='+encodeURIComponent(prod);
      fetch(url).then(function(r){return r.json()}).then(function(j){
        if(!j||!j.html)throw new Error('no html');
        var tmp=document.createElement('div');
        tmp.innerHTML=j.html;
        var incoming=tmp.querySelectorAll('.jdgm-rev');
        Array.prototype.forEach.call(incoming,function(n){list.appendChild(n);hydrateReviewPics(n);linkifyReviewBodies(n);});
        btn.setAttribute('data-page',page);
        var shown=list.querySelectorAll('.jdgm-rev').length;
        if(shown>=total||incoming.length===0){
          btn.parentNode.style.display='none';
          if(status)status.textContent='Showing all '+total+' reviews.';
        } else {
          btn.disabled=false;btn.textContent=label;
          if(status)status.textContent='Showing '+shown+' of '+total+' reviews.';
        }
      }).catch(function(){
        btn.disabled=false;btn.textContent=label;
        if(status)status.textContent='Could not load more reviews right now.';
      });
    });
  });
  document.querySelectorAll('.pills').forEach(function(group){
    group.addEventListener('click',function(e){
      var p=e.target.closest('.pill');if(!p||p.disabled)return;
      group.querySelectorAll('.pill').forEach(function(x){x.classList.remove('on')});
      p.classList.add('on');
      var priceEl=document.querySelector('[data-live-price]');
      if(priceEl&&p.dataset.price){priceEl.textContent=p.dataset.price;}
    });
  });
  /* Variant pills -> real Shopify variant selection, compare-at price, per-hour line */
  document.querySelectorAll('[data-variant-pills]').forEach(function(group){
    var form=group.closest('form');if(!form)return;
    var input=form.querySelector('[data-variant-input]');if(!input)return;
    var badge=document.querySelector('.salebadge');
    var saleLabel=badge?badge.textContent:'Sale';
    group.addEventListener('click',function(e){
      var p=e.target.closest('.pill');if(!p||p.disabled)return;
      input.value=p.dataset.variantId;
      var cmp=document.querySelector('[data-live-compare]');
      if(cmp){
        if(p.dataset.compare){
          cmp.innerHTML='<span class="was"></span><span class="salebadge"></span>';
          cmp.querySelector('.was').textContent=p.dataset.compare;
          cmp.querySelector('.salebadge').textContent=saleLabel;
        } else { cmp.textContent=''; }
      }
      var perEl=document.querySelector('[data-live-per]');
      if(perEl&&typeof p.dataset.sub!=='undefined'){perEl.innerHTML=p.dataset.sub;}
      var url=new URL(window.location.href);
      url.searchParams.set('variant',p.dataset.variantId);
      window.history.replaceState({},'',url);
    });
  });
  /* Coach filter chips (All / TP / LD ...) */
  document.querySelectorAll('[data-coach-filters]').forEach(function(bar){
    var root=bar.closest('.shopify-section')||document;
    var cards=root.querySelectorAll('.coach');
    var counter=root.querySelector('[data-coach-count]');
    var noun=counter?(counter.getAttribute('data-noun')||''):'';
    bar.addEventListener('click',function(e){
      var b=e.target.closest('.chip');if(!b)return;
      bar.querySelectorAll('.chip').forEach(function(x){x.classList.remove('on')});
      b.classList.add('on');
      var m=(b.getAttribute('data-match')||'').toLowerCase();
      var shown=0;
      Array.prototype.forEach.call(cards,function(card){
        var ev=(card.getAttribute('data-events')||'').toLowerCase();
        var hit=(!m)||(ev.indexOf(m)>-1);
        card.style.display=hit?'':'none';
        if(hit)shown++;
      });
      if(counter)counter.textContent=shown+' '+noun;
    });
  });
  var gtrack=document.getElementById('gtrack');
  if(gtrack){
    var originals=Array.prototype.slice.call(gtrack.children);
    var data=originals.map(function(el){return {src:el.dataset.full||el.querySelector('img').src,cap:el.dataset.cap||''}});
    originals.forEach(function(el){gtrack.appendChild(el.cloneNode(true))});
    var lb=document.getElementById('lb');
    if(lb){
      var lbimg=lb.querySelector('img'),lbcap=lb.querySelector('.cap'),idx=0;
      var show=function(i){idx=(i+data.length)%data.length;lbimg.src=data[idx].src;lbcap.textContent=data[idx].cap;};
      var openLb=function(i){show(i);lb.classList.add('open');};
      var closeLb=function(){lb.classList.remove('open');lbimg.src='';};
      gtrack.addEventListener('click',function(e){var it=e.target.closest('.gitem');if(!it)return;openLb(+it.dataset.i);});
      lb.querySelector('.prev').addEventListener('click',function(){show(idx-1)});
      lb.querySelector('.next').addEventListener('click',function(){show(idx+1)});
      lb.querySelector('.close').addEventListener('click',closeLb);
      lb.addEventListener('click',function(e){if(e.target===lb)closeLb();});
      document.addEventListener('keydown',function(e){if(!lb.classList.contains('open'))return;if(e.key==='Escape')closeLb();else if(e.key==='ArrowLeft')show(idx-1);else if(e.key==='ArrowRight')show(idx+1);});
    }
  }
  document.querySelectorAll('.qty').forEach(function(q){
    var input=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(input.value||'1',10);
        v+= (b.dataset.step==='up'?1:-1); if(v<1)v=1;
        input.value=v;
      });
    });
  });
})();
